















import Vue from 'vue'
enum Direction {
  AtoB, BtoA
}

export default Vue.extend({
  computed: {
    moveBtnAvailable(): boolean {
      if (this.$store.state.userA.userId == '' || this.$store.state.userB.userId == '') {
        return false
      }
      return true
    }
  },
  methods: {
    async moveDealFromAtoB() {
      console.log('atob')
      await this.$store.dispatch('moveDeals', Direction.AtoB)
      this.$buefy.toast.open({
          duration: 5000,
          message: `案件担当者・アクティビティの移行に成功しました。`,
          type: 'is-success'
      })
    },
    async moveDealFromBtoA() {
      await this.$store.dispatch('moveDeals', Direction.BtoA)
      this.$buefy.toast.open({
          duration: 5000,
          message: `案件担当者・アクティビティの移行に成功しました。`,
          type: 'is-success'
      })
    }
  }
})
